import { merge } from 'lodash';

function getMessages() {
  const LANGUAGE_PACK = process.env.LANGUAGE_PACK || window._MOKA_ENV_?.LANGUAGE_PACK || '';
  let enUsMessages = window.en_us_messages || {};
  let zhCnMessages = window.zh_cn_messages || {};

  if (LANGUAGE_PACK) {
    enUsMessages = merge(enUsMessages, window[`en_${LANGUAGE_PACK}_messages`] || {});
    zhCnMessages = merge(zhCnMessages, window[`zh_${LANGUAGE_PACK}_messages`] || {});
  }

  if (process.env.NODE_ENV === 'development') {
    enUsMessages = require('../../lingui/en_US/messages').default;
    zhCnMessages = require('../../lingui/zh_CN/messages').default;

    if (LANGUAGE_PACK) {
      enUsMessages = merge(
        enUsMessages,
        require(`../../lingui/en_${LANGUAGE_PACK.toUpperCase()}/messages.js`).default
      );
      zhCnMessages = merge(
        zhCnMessages,
        require(`../../lingui/zh_${LANGUAGE_PACK.toUpperCase()}/messages.js`).default
      );
    }
  }

  return { enUsMessages, zhCnMessages };
}

export default getMessages;
